// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewItem-Container_cls1__cB8-v","cls2":"PaymentChannelViewItem-Container_cls2__0SrK1 PaymentChannelViewItem-Container_cls1__cB8-v"};